const finiteCoordinate = value => value !== null && value !== undefined && String(value).trim() !== '' && Number.isFinite(Number(value));

export function listingLocation(data = {}) {
  const country = String(data.country || 'CO').trim().toLowerCase();
  const colombia = ['co', 'col', 'colombia'].includes(country);
  const lat = Number(data.lat);
  const lng = Number(data.lng);
  const valid = finiteCoordinate(data.lat) && finiteCoordinate(data.lng) &&
    lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180 &&
    (lat !== 0 || lng !== 0) && (!colombia || (lat >= -4.3 && lat <= 13.6 && lng >= -82 && lng <= -66));
  const address = [data.street && !/^0+$/.test(String(data.street).trim()) ? data.street : '', data.city, data.state,
    colombia ? 'Colombia' : data.country].filter(Boolean).join(', ');
  let reference;
  try {
    const payload = typeof data.experiencePayload === 'string' ? JSON.parse(data.experiencePayload) : data.experiencePayload;
    reference = payload && payload.location && payload.location.mapReference;
  } catch (error) { /* Older listings may not have an experience payload. */ }
  const municipalityReference = Boolean(valid && reference && reference.precision === 'municipality' &&
    Number(reference.lat) === lat && Number(reference.lng) === lng);
  return { point: valid ? { lat, lng } : null, address, municipalityReference };
}
